import React from "react";
import IErrorMessageProps from "../../interfaces/ierror_message_props.type";
import './ErrorMessage.scss'

const ErrorMessage: React.FunctionComponent<IErrorMessageProps> = ({
    id,
    className,
    testId,
    message
}) => {
    return (
        <div role='alert' id={id} className={className} data-testid={testId}>{message}</div>
    )
}
export default ErrorMessage

